import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up-down', 'ArrowUpDown', [["path",{"d":"M7.5 17.5v-11m0 0L11 10M7.5 6.5 4 10m12.5-3.5v11m0 0L20 14m-3.5 3.5L13 14","key":"svg-0"}]]);